<template>
  <div class="view">
    <div class="view__inner">
      <div class="text-center">
        <SVGLogo class="view__logo" />
      </div>

      <h2 class="m-t-2">{{ $t('Congratulation! You are successfully registered.') }}</h2>

      <el-alert :closable="false" type="success" class="m-t-1">
        <template slot="title">
          <p>
            {{ $t('Before you can login in we need to verify your account. This will be processed manually and take some time.') }}
          </p>
          <p>{{ $t('We will notify you via eMail after your account has been activated.') }}</p>
        </template>
      </el-alert>

      <p class="text-center m-t-1">
        <router-link tag="el-button" :to="{ path: '/login' }" class="w-100 m-t-1">{{ $t('Login') }}</router-link>
      </p>
    </div>

    <p class="view__footer">
      <a href="https://gpal.epal-pallets.org/menus/menu-marginal/impressum/" target="_blank" :title="$t('Imprint')" class="color-gray">
        {{ $t('Imprint') }}
      </a>
    </p>
  </div>
</template>

<script>
/* eslint-disable max-len */
import SVGLogo from '@/assets/img/epal-deutschland-black.svg';

export default {
  name: 'RegisterComplete',

  components: {
    SVGLogo
  }
};
</script>

<style lang="scss" scoped>
.view {
  &__inner {
    max-width: 50rem;
  }
}
</style>
